import styled, { keyframes } from 'styled-components';
import Card from 'components/common/Card';

export const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const move = keyframes`
  0% {
    opacity: 0.5;
    transform: scale(0.8, 0.8);
  }

  60% {
    opacity: 1;
    transform: scale(1.1, 1.1);
  }

  100% {
    transform: scale(1, 1);
  }
`;

export const Header = styled.div`
  padding: 16px;
  padding-bottom: 0px;
  max-height: 120px;
`;

export const Divider = styled.div`
  flex: 1;
  height: 1px;
  background-color: #9c9c9c70;
`;

export const DialogContainer = styled.div`
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  z-index: 99999999;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const Flex = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
`;

export const Actions = styled.div`
  display: flex;
  padding: 24px;
  padding-top: 0px;
  max-height: 60px;
  flex-direction: row;
  justify-content: space-between;
`;

export const InnerContain = styled.div`
  height: 100%;
`;

export const Content = styled.div`
  flex: 1;
  padding: 16px;
  padding-top: 0px;
`;

export const Container = styled.div`
  width: 80vw;
  max-width: 640px;
  max-height: 90vh;
  position: absolute;
  will-change: opacity, transform;
  animation: ${move} 0.4s ease-out;

  ${props => props.theme.media.sm.max`
    width: 90vw !important;
  `}
`;

export const Overlay = styled.div`
  top: 0px;
  left: 0px;
  z-index: 9999999;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
  position: fixed;
  will-change: background-color;
  animation: ${opacity} 0.15s linear;
  background-color: rgba(0, 0, 0, 0.40);

  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

export const MarginBottom = styled.div`
  margin-bottom: 16px;
`;

export const DisplayButton = styled.div`
  visibility: ${props => props.hide ? 'hidden' : 'visible'}
`;

export const TopRight = styled.div`
  right: 24px;
  cursor: pointer;
  top: 24px;
  z-index: 999;
  position: absolute;
`;

export const DialogTitle = styled(Card.Title)`
  font-size: 1.5em;
`;

export const LoadingContain = styled.div`
  display: flex;
  font-family: 'Roboto';
  font-size: 1.1em;
  line-height: 2em;
  color: ${(props) => props.theme.brandColor};
  margin-top: 0.5em;
  margin-bottom: 01em;
  font-weight: 500;
  justify-content: center;
`;
